import { render, staticRenderFns } from "./IcoCalloutX.vue?vue&type=template&id=ed0773c2"
import script from "./IcoCalloutX.vue?vue&type=script&lang=js"
export * from "./IcoCalloutX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports